import forms from './forms/_forms'
import subheader from './subheader/_subheader'
import contribute from './contribute/_contribute'
import addcontent from './addcontent/_addcontent'
import userprofile from './adduserprofile/_adduserprofile'
import addevent from './addevent/_addevent'
import confirmaccount from './confirmaccount/_confirmaccount'
import forgotpassword from './forgotpassword/_forgotpassword'
import categories from './categories/_categories'
import pilotareas from './pilotareas/_pilotareas'
import countries from './countries/_countries'
import portal from './portal/_portal'
import additional from './additional/additional'
import professionalgroups from './professionalgroups/_professionalgroups'
import layers from './layers/_layers'
import landingpage from './landingpage/_landingpage'
import cookies from "./cookies/_cookies";

const de = forms.concat(
    subheader,
    contribute,
    addcontent,
    userprofile,
    addevent,
    confirmaccount,
    forgotpassword,
    categories,
    pilotareas,
    countries,
    portal,
    additional,
    professionalgroups,
    layers,
    landingpage,
    cookies
)

export default de



// WEBPACK FOOTER //
// ./src/i18n/de/de.js